import React, { useState } from "react";
import "./ApplicationForm.css";
 
const ApplicationForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    location: "",
    email: "",
    phone: "",
    institution: "",
    message: "",
    resume: null,
    agree: false,
  });
 
  const [loading, setLoading] = useState(false);
 
  // Handle input changes
  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    setFormData({
      ...formData,
      [name]:
        type === "checkbox"
          ? checked
          : type === "file"
          ? files[0]
          : value,
    });
  };
 
  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
 
    try {
      const formDataObj = new FormData();
      Object.keys(formData).forEach((key) => {
        formDataObj.append(key, formData[key]);
      });
 
      const res = await fetch("https://novaedubridge.com/sendApplication.php", {
        method: "POST",
        body: formDataObj,
      });
 
      const result = await res.json();
      alert(result.message);
 
      if (result.status === "success") {
        setFormData({
          name: "",
          location: "",
          email: "",
          phone: "",
          institution: "",
          message: "",
          resume: null,
          agree: false,
        });
      }
    } catch (error) {
      alert("Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };
 
  return (
    <div className="application-form container mt-5">
      <h2 className="heading fw-bold mb-3" style={{ color: "#da1313" }}>
        Application Form
      </h2>
      <p className="text-muted">
        Step into success — your career at <b>Nova EduBridge</b> starts here. <br />
        Apply now for current openings or share your interest in internships by
        filling out our form.
      </p>
 
      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <input
            type="text"
            name="name"
            placeholder="Your Name *"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="location"
            placeholder="Your Location *"
            value={formData.location}
            onChange={handleChange}
            required
          />
        </div>
 
        <div className="form-row">
          <input
            type="email"
            name="email"
            placeholder="Your Email *"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="phone"
            placeholder="Phone No *"
            value={formData.phone}
            onChange={handleChange}
            required
          />
        </div>
 
        <div className="form-row">
          <input
            type="text"
            name="institution"
            placeholder="Your institution name *"
            value={formData.institution}
            onChange={handleChange}
            required
          />
          <label className="upload-btn">
            Upload Your Resume
            <input
              type="file"
              name="resume"
              onChange={handleChange}
              hidden
              required
            />
          </label>
        </div>
 
        <textarea
          name="message"
          placeholder="Write your message *"
          value={formData.message}
          onChange={handleChange}
          required
        ></textarea>
 
        <div className="form-check">
          <input
            type="checkbox"
            name="agree"
            checked={formData.agree}
            onChange={handleChange}
            required
          />
          <span>
            By submitting this form, you acknowledge that Nova EduBridge may use
            your personal information for marketing communications as outlined
            in its privacy policy *
          </span>
        </div>
 
        <button type="submit" className="submit-btn" disabled={loading}>
          {loading ? "Submitting..." : "Submit"}
        </button>
      </form>
    </div>
  );
};
 
export default ApplicationForm;